import { readShopStorage, removeShopStorage, writeShopStorage } from '~/utils/shopStorage'

const STORAGE_SUFFIX = 'age_verified_at'
const LEGACY_STORAGE_SUFFIX = 'age_verified'
const TTL_MS = 24 * 60 * 60 * 1000

export function isAgeVerificationValid(slug: string): boolean {
  if (!import.meta.client) return true

  const raw = readShopStorage(slug, STORAGE_SUFFIX)
  if (!raw) {
    if (readShopStorage(slug, LEGACY_STORAGE_SUFFIX) === 'true') {
      removeShopStorage(slug, LEGACY_STORAGE_SUFFIX)
    }
    return false
  }

  const confirmedAt = Number.parseInt(raw, 10)
  if (!Number.isFinite(confirmedAt) || Date.now() - confirmedAt >= TTL_MS) {
    removeShopStorage(slug, STORAGE_SUFFIX)
    return false
  }

  return true
}

export function saveAgeVerification(slug: string): void {
  writeShopStorage(slug, STORAGE_SUFFIX, String(Date.now()))
  removeShopStorage(slug, LEGACY_STORAGE_SUFFIX)
}
